import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import RequireAuth from "./RequireAuth";

import Loadable from "../layouts/full/shared/loadable/Loadable";
// ============================Device==========================

import Device from "src/views/master/device/Device";
import AddDevice from "src/views/master/device/AddDevice";
import UpdateDevice from "src/views/master/device/UpdateDevice";

// ----------------- vehicle category area  ---------------------
import Vehicle from "src/views/master/vehicle/Vehicle";
import AddvehicleCategory from "src/views/master/vehicle/AddvehicleCategory";
import UpdateVehicleCate from "src/views/master/vehicle/UpdateVehicleCate";

// ------------------- Plan and subscription area  ---------------------
import PlanSubscriptionList from "src/views/master/planSubscription/PlanSubscriptionList";
import AddPlanSubscription from "src/views/master/planSubscription/AddPlanSubscription";
import UpdatePlanSubscription from "src/views/master/planSubscription/UpdatePlanSubscription";

// ------------------- wheel type area  ---------------------
import Wheel from "src/views/master/wheel/Wheel";
import AddWheelType from "src/views/master/wheel/AddWheelType";
import UpdateWheelType from "src/views/master/wheel/UpdateWheelType";

// ===============================Driver Data ===============================
import Driver from "src/views/master/driver/Driver";
import AddDriver from "src/views/master/driver/addDriver";
import UpdateDriver from "src/views/master/driver/updateDriver";

// ==============================Vehicle Route ==========================
import Route from "src/views/master/route/Route";

import VehichleListView from "src/views/master/vehicle/VehichleListView";

import AddNewRoute from "src/views/master/newRoute/AddNewRoute";
import UpdateNewRoute from "src/views/master/newRoute/UpdateNewRoute";

// ===============================Assign Driver Data ===============================
import AssignVehicle2Driver from "src/views/master/assignVehicle/AssignVehicle2Driver";
import AssignVehicletoDriver from "src/views/master/assignVehicle/AssignVehicle_to_Driver";
import UpdateAssignVehicle from "src/views/master/assignVehicle/updateAssignVehicleDriver";

// ===============================Vehicle Details Area ===============================
import VehicleDetailsList from "src/views/master/vehicleDetails/VehicleDetailsList";
import AddVehicleDetails from "src/views/master/vehicleDetails/AddVehicleDetails";
import UpdateVehicleDetails from "src/views/master/vehicleDetails/UpdateVehicleDetails";

// ========================= Device Installation =================
import DeviceInstallationForm from "src/views/deviceInstallation/DeviceInstallationForm";

// =================== route allotment to vehicle ============================
import RouteAllotmentTovehicle from "src/views/allotment/routeAllotmentToVehicle/RouteAllotmentToVehicle";

// ================= Geofencing ====================
import Geofencing from "src/views/master/geofencing/Geofencing";
import Addgeofencing from "src/views/master/geofencing/Addgeofencing";
import UpdateGeofencing from "src/views/master/geofencing/UpdateGeofencing";

// ========================= Profile area =================
import DriverProfile from "src/views/profile/DriverProfile";
import Routemap from "src/components/routeMap/RouteMap";

// ======================= Reports ==========================
import VehicleRouteAllotmentReport from "src/views/reports/VehicleRouteAllotmentReport";

// ======================= Reports ==========================
import DeviceInstallationReport from "src/views/reports/DeviceInstallationReport";
import DeviceStockReport from "src/views/reports/DeviceStockReport";
import VehiclegeofenceReport from "src/views/reports/VehiclegeofenceReport";

// =================== change password ===========================

import ChangePassword from "../views/password/ChangePassword";
import FencingAllotmenttoVehicle from "src/views/allotment/vehicle2geofencing/FencingAllotmenttoVehicle";

// ================= trip ==============================
import SingleTripDetails from "src/views/vehicle/vehicleDetails/vehicleProfileTabs/trip/SingleTripDetails";

// ====================== Driver Dashboard ==========================

import DriverDashboard from "src/views/dashboard/driver/DriverDashboard";

// ---------------------  device defect ------------------------

import DeviceDefect from "src/views/master/deviceDefect/DeviceDefect";
import AddDeviceDefect from "src/views/master/deviceDefect/AddDeviceDefect";
import UpdateDeviceDefect from "src/views/master/deviceDefect/UpdateDeviceDefect";

// ------------- alert map -----------------------
import AlertMap from "src/views/vehicle/vehicleDetails/vehicleProfileTabs/alert/AlertMap";
import AllVehiclemap from "src/views/vehicle/vehicleDetails/routeReplay/AllVehicleMap";

// -------------------  bulk vehicle upload ----------------------
import AddBulkVehicle from "src/views/master/bulkVehicle/AddBulkvehicle";
import BulkVehicleList from "src/views/master/bulkVehicle/BulkVehicleList";
import UpdateBulkVehicle from "src/views/master/bulkVehicle/UpdateBulkVehicle";
import VehicleTable from "src/views/master/bulkVehicle/VehicleTable";

// ------- nearby vehicle  ---------------------------

import NearbyVehicle from "src/views/vehicle/vehicleDetails/nearbyVehicle/NearbyVehicle";

// -------------- dynamic Logo --------------------------

import AddDynamicLogo from "src/views/master/dynamicLogo/AddDynamicLogo";
import UpdateDynamicLogo from "src/views/master/dynamicLogo/UpdateDynamicLogo";
import DynamicLogoList from "src/views/master/dynamicLogo/DynamicLogoList";

// ----------- userlist ----------------------
import UserList from "src/views/master/user/UserList";
import AddUserList from "src/views/master/user/AddUserList";
import UpdateUserlist from "src/views/master/user/UpdateUserlist";
import ChangeUserPassword from "src/views/master/user/ChangeUserPassword";

// --------- thana user list -----------------------

import ThanauserList from "src/views/master/thanaUser/ThanaUserList";
import AddThanaUser from "src/views/master/thanaUser/AddThanaUser";
import UpdateThanaUser from "src/views/master/thanaUser/UpdateThanaUser";

// ----------- vehicle allot to thana user -------------------
import AllotVehicleToThanaUser from "src/views/allotment/vehicletothanauser/AllotVehicleToThanaUser";

import VehicleAllotTothanauserList from "src/views/reports/VehicleAllotToThanaUserList";

// ------------------------------------------------------

import LocationWiseFenceList from "src/views/master/geofenceSetup/LocationWiseFenceList";
import AddLocationWiseFence from "src/views/master/geofenceSetup/AddLocationWiseFence";
import UpdateLocationWiseFenceList from "src/views/master/geofenceSetup/UpdateLocationWiseFenceList";
import HomeSiteFenceList from "src/views/master/geofenceSetup/HomeSiteFenceList";
import AddHomeSiteFenceList from "src/views/master/geofenceSetup/AddHomeSiteFenceList";
import UpdateHomeSiteList from "src/views/master/geofenceSetup/UpdateHomeSiteList";
import RestrictedAreaList from "src/views/master/geofenceSetup/RestrictedAreaList";
import AddRestrictedAreaList from "src/views/master/geofenceSetup/AddRestrictedAreaList";
import UpdateRestrictedAreaList from "src/views/master/geofenceSetup/UpdateRestrictedAreaList";

import FencingAllottoMultipleVehicle from "src/views/allotment/multipleFencingAllotment/FencingAllottoMultipleVehicle";

// ----------- vehicle performance report --------------------

import PerformanceReportVehiclewise from "src/views/reports/PerformanceReportVehiclewise";
import PerformanceReportDatewise from "src/views/reports/PerformanceReportDatewise";

// -------- time zone -----------------

import TimeSlotList from "src/views/master/timeslot/TimeSlotList";
import AddTimeSlotList from "src/views/master/timeslot/AddTimeSlotList";
import UpdateTimeSlotList from "src/views/master/timeslot/UpdateTimeSlotList";

// ----------- ecalation list ---------------------

import Escalationlist from "src/views/master/escalation/Escalation_list";
import AddEscalationList from "src/views/master/escalation/Add_EscalationList";
import UpdateEscalationList from "src/views/master/escalation/Update_EscalationList";

// ------------------ alert report --------------------------------
import GeofenceAlertReport from "src/views/reports/GeofenceAlertReport";
import EscalationReport from "src/views/reports/EscalationReport";
import PointofInterestReport from "src/views/reports/PointofInterestReport";

// ---------- poi location  ---------

import POILocation from "src/views/master/PoiLocation/POILocation";
import AddPOILocation from "src/views/master/PoiLocation/AddPOILocation";
import UpdatePOILocation from "src/views/master/PoiLocation/UpdatePOILocation";

// ----------------ABHISHEK----------------

// ------------Event Log Report --------------------
import EventLog from "src/views/reports/EventLog";
// import { element, exact } from "prop-types";

const VehicleDetails = Loadable(
  lazy(() => import("../views/vehicle/vehicleDetails"))
);

const RouteReplay = Loadable(
  lazy(() => import("../views/vehicle/vehicleDetails/routeReplay"))
);

const LiveLocation = Loadable(
  lazy(() => import("../views/vehicle/liveLocation"))
);

const ModernDash = Loadable(lazy(() => import("../views/dashboard/Modern")));

// ----------------ABHISHEK----------------

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

/* ****Pages***** */
// const ModernDash = Loadable(lazy(() => import("../views/dashboard/Modern")));
const EcommerceDash = Loadable(
  lazy(() => import("../views/dashboard/Ecommerce"))
);

/* ****Apps***** */
const Chats = Loadable(lazy(() => import("../views/apps/chat/Chat")));
const Notes = Loadable(lazy(() => import("../views/apps/notes/Notes")));
const Calendar = Loadable(
  lazy(() => import("../views/apps/calendar/BigCalendar"))
);
const Email = Loadable(lazy(() => import("../views/apps/email/Email")));
const Blog = Loadable(lazy(() => import("../views/apps/blog/Blog")));
const BlogDetail = Loadable(lazy(() => import("../views/apps/blog/BlogPost")));
const Tickets = Loadable(lazy(() => import("../views/apps/tickets/Tickets")));
const Contacts = Loadable(
  lazy(() => import("../views/apps/contacts/Contacts"))
);
const Ecommerce = Loadable(
  lazy(() => import("../views/apps/eCommerce/Ecommerce"))
);
const EcommerceDetail = Loadable(
  lazy(() => import("../views/apps/eCommerce/EcommerceDetail"))
);
const EcomProductList = Loadable(
  lazy(() => import("../views/apps/eCommerce/EcomProductList"))
);
const EcomProductCheckout = Loadable(
  lazy(() => import("../views/apps/eCommerce/EcommerceCheckout"))
);
const UserProfile = Loadable(
  lazy(() => import("../views/apps/user-profile/UserProfile"))
);
const Followers = Loadable(
  lazy(() => import("../views/apps/user-profile/Followers"))
);
const Friends = Loadable(
  lazy(() => import("../views/apps/user-profile/Friends"))
);
const Gallery = Loadable(
  lazy(() => import("../views/apps/user-profile/Gallery"))
);

// Pages
const RollbaseCASL = Loadable(
  lazy(() => import("../views/pages/rollbaseCASL/RollbaseCASL"))
);
const Treeview = Loadable(
  lazy(() => import("../views/pages/treeview/Treeview"))
);
const Pricing = Loadable(lazy(() => import("../views/pages/pricing/Pricing")));
const AccountSetting = Loadable(
  lazy(() => import("../views/pages/account-setting/AccountSetting"))
);
const Faq = Loadable(lazy(() => import("../views/pages/faq/Faq")));

// widget
const WidgetCards = Loadable(
  lazy(() => import("../views/widgets/cards/WidgetCards"))
);
const WidgetBanners = Loadable(
  lazy(() => import("../views/widgets/banners/WidgetBanners"))
);
const WidgetCharts = Loadable(
  lazy(() => import("../views/widgets/charts/WidgetCharts"))
);

// form elements
const MuiAutoComplete = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiAutoComplete"))
);
const MuiButton = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiButton"))
);
const MuiCheckbox = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiCheckbox"))
);
const MuiRadio = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiRadio"))
);
const MuiSlider = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiSlider"))
);
const MuiDateTime = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiDateTime"))
);
const MuiSwitch = Loadable(
  lazy(() => import("../views/forms/form-elements/MuiSwitch"))
);

// form layout
const FormLayouts = Loadable(lazy(() => import("../views/forms/FormLayouts")));
const FormCustom = Loadable(lazy(() => import("../views/forms/FormCustom")));
const FormWizard = Loadable(lazy(() => import("../views/forms/FormWizard")));
const FormValidation = Loadable(
  lazy(() => import("../views/forms/FormValidation"))
);
const QuillEditor = Loadable(
  lazy(() => import("../views/forms/quill-editor/QuillEditor"))
);
const FormHorizontal = Loadable(
  lazy(() => import("../views/forms/FormHorizontal"))
);
const FormVertical = Loadable(
  lazy(() => import("../views/forms/FormVertical"))
);

// tables
const BasicTable = Loadable(lazy(() => import("../views/tables/BasicTable")));
const CollapsibleTable = Loadable(
  lazy(() => import("../views/tables/CollapsibleTable"))
);
const EnhancedTable = Loadable(
  lazy(() => import("../views/tables/EnhancedTable"))
);
const FixedHeaderTable = Loadable(
  lazy(() => import("../views/tables/FixedHeaderTable"))
);
const PaginationTable = Loadable(
  lazy(() => import("../views/tables/PaginationTable"))
);
const SearchTable = Loadable(lazy(() => import("../views/tables/SearchTable")));

// chart
const LineChart = Loadable(lazy(() => import("../views/charts/LineChart")));
const GredientChart = Loadable(
  lazy(() => import("../views/charts/GredientChart"))
);
const DoughnutChart = Loadable(
  lazy(() => import("../views/charts/DoughnutChart"))
);
const AreaChart = Loadable(lazy(() => import("../views/charts/AreaChart")));
const ColumnChart = Loadable(lazy(() => import("../views/charts/ColumnChart")));
const CandlestickChart = Loadable(
  lazy(() => import("../views/charts/CandlestickChart"))
);
const RadialbarChart = Loadable(
  lazy(() => import("../views/charts/RadialbarChart"))
);

// ui
const MuiAlert = Loadable(
  lazy(() => import("../views/ui-components/MuiAlert"))
);
const MuiAccordion = Loadable(
  lazy(() => import("../views/ui-components/MuiAccordion"))
);
const MuiAvatar = Loadable(
  lazy(() => import("../views/ui-components/MuiAvatar"))
);
const MuiChip = Loadable(lazy(() => import("../views/ui-components/MuiChip")));
const MuiDialog = Loadable(
  lazy(() => import("../views/ui-components/MuiDialog"))
);
const MuiList = Loadable(lazy(() => import("../views/ui-components/MuiList")));
const MuiPopover = Loadable(
  lazy(() => import("../views/ui-components/MuiPopover"))
);
const MuiRating = Loadable(
  lazy(() => import("../views/ui-components/MuiRating"))
);
const MuiTabs = Loadable(lazy(() => import("../views/ui-components/MuiTabs")));
const MuiTooltip = Loadable(
  lazy(() => import("../views/ui-components/MuiTooltip"))
);
const MuiTransferList = Loadable(
  lazy(() => import("../views/ui-components/MuiTransferList"))
);
const MuiTypography = Loadable(
  lazy(() => import("../views/ui-components/MuiTypography"))
);

// authentication
const Login = Loadable(
  lazy(() => import("../views/authentication/auth1/Login"))
);
const Login2 = Loadable(
  lazy(() => import("../views/authentication/auth2/Login2"))
);
const Register = Loadable(
  lazy(() => import("../views/authentication/auth1/Register"))
);
const Register2 = Loadable(
  lazy(() => import("../views/authentication/auth2/Register2"))
);
const ForgotPassword = Loadable(
  lazy(() => import("../views/authentication/auth1/ForgotPassword"))
);
const ForgotPassword2 = Loadable(
  lazy(() => import("../views/authentication/auth2/ForgotPassword2"))
);
const TwoSteps = Loadable(
  lazy(() => import("../views/authentication/auth1/TwoSteps"))
);
const TwoSteps2 = Loadable(
  lazy(() => import("../views/authentication/auth2/TwoSteps2"))
);
const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance"))
);

// landingpage
const Landingpage = Loadable(
  lazy(() => import("../views/pages/landingpage/Landingpage"))
);

const Router = [
  {
    path: "/",
    element: (
      <RequireAuth>
        <FullLayout />
      </RequireAuth>
    ),
    children: [
      // { path: "/", element: <Navigate to="/auth/login" /> },
      { path: "/", exact: true, element: <ModernDash /> },
      {
        path: "/dashboards/ecommerce",
        exact: true,
        element: <EcommerceDash />,
      },

      {
        path: "/vehicle/details/:vehicle_no",
        exact: true,
        element: <VehicleDetails />,
      },

      // ============================Driver=================================

      {
        path: "/driver",
        exact: true,
        element: <Driver />,
      },
      {
        path: "/adddriver",
        exact: true,
        element: <AddDriver />,
      },
      {
        path: "/updatedriver/:id",
        exact: true,
        element: <UpdateDriver />,
      },
      // {
      //   path: "",
      //   exact: true,
      //   element: </>,
      // },

      // ================================Device============================
      {
        path: "/device",
        exact: true,
        element: <Device />,
      },
      {
        path: "/adddevice",
        exact: true,
        element: <AddDevice />,
      },
      {
        path: "/updatedevice/:id",
        exact: true,
        element: <UpdateDevice />,
      },

      {
        path: "/bulkvehiclelist",
        exact: true,
        element: <BulkVehicleList />,
      },
      {
        path: "/addbulkvehicle",
        exact: true,
        element: <AddBulkVehicle />,
      },
      {
        path: "/updatebulkvehicle/:id",
        exact: true,
        element: <UpdateBulkVehicle />,
      },
      {
        path: "/vehicletable",
        exact: true,
        element: <VehicleTable />,
      },
      {
        path: "/nearbyvehicle",
        exact: true,
        element: <NearbyVehicle />,
      },

      // ======================Vehicle category area ===================

      {
        path: "/vehicle",
        exact: true,
        element: <Vehicle />,
      },
      {
        path: "/addVehicle",
        exact: true,
        element: <AddvehicleCategory />,
      },
      {
        path: "/updateVehicle/:id",
        exact: true,
        element: <UpdateVehicleCate />,
      },

      // ======================Plan and subscription area by samir===================

      {
        path: "/planAndSubscription",
        exact: true,
        element: <PlanSubscriptionList />,
      },
      {
        path: "/addPlanAndSubscription",
        exact: true,
        element: <AddPlanSubscription />,
      },
      {
        path: "/updateSubscription/:id",
        exact: true,
        element: <UpdatePlanSubscription />,
      },

      // ======================wheel area ===================
      {
        path: "/wheelType",
        exact: true,
        element: <Wheel />,
      },
      {
        path: "/addWheelType",
        exact: true,
        element: <AddWheelType />,
      },
      {
        path: "/updateWheel/:id",
        exact: true,
        element: <UpdateWheelType />,
      },

      // ======================Vehicle category area ===================
      {
        path: "/vehicle",
        exact: true,
        element: <Vehicle />,
      },
      {
        path: "/addVehicle",
        exact: true,
        element: <AddvehicleCategory />,
      },
      {
        path: "/updateVehicle/:id",
        exact: true,
        element: <UpdateVehicleCate />,
      },

      // ======================Vehicle Details area ===================
      {
        path: "/vehicleDetailsLists",
        exact: true,
        element: <VehicleDetailsList />,
      },
      {
        path: "/addVehicleDetails",
        exact: true,
        element: <AddVehicleDetails />,
      },
      {
        path: "/updateVehicleDetails/:id",
        exact: true,
        element: <UpdateVehicleDetails />,
      },
      {
        path: "/vehichleList",
        exact: true,
        element: <VehichleListView />,
      },

      // ***************** Assign Driver **************
      {
        path: "/assignVehicleDriver",
        exact: true,
        element: <AssignVehicle2Driver />,
      },
      {
        path: "/assignDriver",
        exact: true,
        element: <AssignVehicletoDriver />,
      },
      {
        path: "/updateassignDriver/:id",
        exact: true,
        element: <UpdateAssignVehicle />,
      },

      {
        path: "/route",
        exact: true,
        element: <Route />,
      },
      {
        path: "/addnewroute",
        exact: true,
        element: <AddNewRoute />,
      },
      {
        path: "/updatenewroute/:id",
        exact: true,
        element: <UpdateNewRoute />,
      },

      // ==================== route allotment to vehicle ================
      {
        path: "/routeallot2vehicle",
        exact: true,
        element: <RouteAllotmentTovehicle />,
      },
      {
        path: "/vehiclerouteallotmentreport",
        exact: true,
        element: <VehicleRouteAllotmentReport />,
      },

      // ================= Geofencing ===========================
      {
        path: "/geofencing",
        exact: true,
        element: <Geofencing />,
      },
      {
        path: "/addgeofencing",
        exact: true,
        element: <Addgeofencing />,
      },
      {
        path: "/updategeofencing/:id",
        exact: true,
        element: <UpdateGeofencing />,
      },

      {
        path: "/fencingallottovehicle",
        exact: true,
        element: <FencingAllotmenttoVehicle />,
      },

      // ************ device Installation *****************
      {
        path: "/installDevice",
        exact: true,
        element: <DeviceInstallationForm />,
      },

      // ======================= Reports =============================

      {
        path: "/deviceInstallationReport",
        exact: true,
        element: <DeviceInstallationReport />,
      },
      {
        path: "/deviceStockReport",
        exact: true,
        element: <DeviceStockReport />,
      },
      {
        path: "/geofencereport",
        exact: true,
        element: <VehiclegeofenceReport />,
      },

      // ********************** profile area ******************
      {
        path: "/driverProfile",
        exact: true,
        element: <DriverProfile />,
      },

      // ================== testing map =================
      {
        path: "/routemap",
        exact: true,
        element: <Routemap />,
      },

      // ===========  change password ============

      {
        path: "/changepassword",
        exact: true,
        element: <ChangePassword />,
      },

      // ------------ Trip ----------------------
      {
        path: "/singletripdetails/:id",
        exact: true,
        element: <SingleTripDetails />,
      },

      // ============= device defect ===========
      {
        path: "/devicedefect",
        exact: true,
        element: <DeviceDefect />,
      },
      {
        path: "/adddevicedefect",
        exact: true,
        element: <AddDeviceDefect />,
      },
      {
        path: "/updatedevicedefect/:id",
        exact: true,
        element: <UpdateDeviceDefect />,
      },

      // ----------ABHISHEK-----------
      {
        path: "/vehicle/details/:imei",
        exact: true,
        element: <VehicleDetails />,
      },

      {
        path: "/vehicle/details/routeReplay/:id",
        exact: true,
        element: <RouteReplay />,
      },
      {
        path: "/vehicle/live/:id",
        exact: true,
        element: <LiveLocation />,
      },
      {
        path: "/vehicle/live",
        exact: true,
        element: <LiveLocation />,
      },
      {
        path: "/driverDashboard/:id",
        exact: true,
        element: <DriverDashboard />,
      },

      // --------------------- alert maps -------------
      {
        path: "/alertmap/:id",
        exact: true,
        element: <AlertMap />,
      },
      {
        path: "/vehiclemap/:vehicle_no",
        exact: true,
        element: <AllVehiclemap />,
      },

      // ----------------------- dynamic logo ----------------------

      {
        path: "/dynamiclogolist",
        exact: true,
        element: <DynamicLogoList />,
      },
      {
        path: "/adddynamiclogo",
        exact: true,
        element: <AddDynamicLogo />,
      },
      {
        path: "/updatedynamiclogo/:id",
        exact: true,
        element: <UpdateDynamicLogo />,
      },

      {
        path: "/userlist",
        exact: true,
        element: <UserList />,
      },
      {
        path: "/adduserlist",
        exact: true,
        element: <AddUserList />,
      },
      {
        path: "/updateuserlist/:id",
        exact: true,
        element: <UpdateUserlist />,
      },

      {
        path: "/timeslot",
        exact: true,
        element: <TimeSlotList />,
      },
      {
        path: "/addtimeslot",
        exact: true,
        element: <AddTimeSlotList />,
      },
      {
        path: "/updatetimeslot/:id",
        exact: true,
        element: <UpdateTimeSlotList />,
      },

      {
        path: "/Escalation",
        exact: true,
        element: <Escalationlist />,
      },
      {
        path: "/addEscalation",
        exact: true,
        element: <AddEscalationList />,
      },
      {
        path: "/updateEscalation/:id",
        exact: true,
        element: <UpdateEscalationList />,
      },

      {
        path: "/changeuserpassword/:id",
        exact: true,
        element: <ChangeUserPassword />,
      },

      {
        path: "/thanauserlist",
        exact: true,
        element: <ThanauserList />,
      },
      {
        path: "/addthanauser",
        exact: true,
        element: <AddThanaUser />,
      },
      {
        path: "/updatethanauser/:id",
        exact: true,
        element: <UpdateThanaUser />,
      },

      // --------------
      {
        path: "/locationwisefencelist",
        exact: true,
        element: <LocationWiseFenceList />,
      },
      {
        path: "/addlocationwisefencelist",
        exact: true,
        element: <AddLocationWiseFence />,
      },
      {
        path: "/updatelocationwisefencelist/:id",
        exact: true,
        element: <UpdateLocationWiseFenceList />,
      },
      {
        path: "/homesitefencelist",
        exact: true,
        element: <HomeSiteFenceList />,
      },
      {
        path: "/addhomesitefencelist",
        exact: true,
        element: <AddHomeSiteFenceList />,
      },
      {
        path: "/updatehomesitefencelist/:id",
        exact: true,
        element: <UpdateHomeSiteList />,
      },

      {
        path: "/poilocation",
        exact: true,
        element: <POILocation />,
      },
      {
        path: "/addpoilocation",
        exact: true,
        element: <AddPOILocation />,
      },
      {
        path: "/updatepoilocation/:id",
        exact: true,
        element: <UpdatePOILocation />,
      },

      {
        path: "/restrictedarealist",
        exact: true,
        element: <RestrictedAreaList />,
      },
      {
        path: "/addrestrictedarealist",
        exact: true,
        element: <AddRestrictedAreaList />,
      },
      {
        path: "/updaterestrictedarealist/:id",
        exact: true,
        element: <UpdateRestrictedAreaList />,
      },
      // --------------
      {
        path: "/allotvehicletothanauser",
        exact: true,
        element: <AllotVehicleToThanaUser />,
      },
      {
        path: "/vehicleallottothanauser",
        exact: true,
        element: <VehicleAllotTothanauserList />,
      },

      {
        path: "/performancereportvehicle",
        exact: true,
        element: <PerformanceReportVehiclewise />,
      },
      {
        path: "/performancereportdate",
        exact: true,
        element: <PerformanceReportDatewise />,
      },
      {
        path: "/multiplefencingallotment",
        exact: true,
        element: <FencingAllottoMultipleVehicle />,
      },
      {
        path: "/geofencealertreport",
        exact: true,
        element: <GeofenceAlertReport />,
      },
      {
        path: "/escalationReport",
        exact: true,
        element: <EscalationReport />,
      },
      {
        path: "/pointofinterestreport",
        exact: true,
        element: <PointofInterestReport />,
      },

      // ----------ABHISHEK-----------

      {
        path: "/eventLog",
        exact: true,
        element: <EventLog />,
      },

      { path: "/apps/chats", element: <Chats /> },
      { path: "/apps/notes", element: <Notes /> },
      { path: "/apps/calendar", element: <Calendar /> },
      { path: "/apps/email", element: <Email /> },
      { path: "/apps/tickets", element: <Tickets /> },
      { path: "/apps/contacts", element: <Contacts /> },
      { path: "/apps/ecommerce/shop", element: <Ecommerce /> },
      { path: "/apps/blog/posts", element: <Blog /> },
      { path: "/apps/blog/detail/:id", element: <BlogDetail /> },
      {
        path: "/apps/ecommerce/eco-product-list",
        element: <EcomProductList />,
      },
      {
        path: "/apps/ecommerce/eco-checkout",
        element: <EcomProductCheckout />,
      },
      { path: "/apps/ecommerce/detail/:id", element: <EcommerceDetail /> },
      { path: "/apps/followers", element: <Followers /> },
      { path: "/apps/friends", element: <Friends /> },
      { path: "/apps/gallery", element: <Gallery /> },
      { path: "/user-profile", element: <UserProfile /> },
      { path: "/pages/casl", element: <RollbaseCASL /> },
      { path: "/pages/treeview", element: <Treeview /> },
      { path: "/pages/pricing", element: <Pricing /> },
      { path: "/pages/account-settings", element: <AccountSetting /> },
      { path: "/pages/faq", element: <Faq /> },
      {
        path: "/forms/form-elements/autocomplete",
        element: <MuiAutoComplete />,
      },
      { path: "/forms/form-elements/button", element: <MuiButton /> },
      { path: "/forms/form-elements/checkbox", element: <MuiCheckbox /> },
      { path: "/forms/form-elements/radio", element: <MuiRadio /> },
      { path: "/forms/form-elements/slider", element: <MuiSlider /> },
      { path: "/forms/form-elements/date-time", element: <MuiDateTime /> },
      { path: "/forms/form-elements/switch", element: <MuiSwitch /> },
      { path: "/forms/form-elements/switch", element: <MuiSwitch /> },
      { path: "/forms/quill-editor", element: <QuillEditor /> },
      { path: "/forms/form-layouts", element: <FormLayouts /> },
      { path: "/forms/form-horizontal", element: <FormHorizontal /> },
      { path: "/forms/form-vertical", element: <FormVertical /> },
      { path: "/forms/form-custom", element: <FormCustom /> },
      { path: "/forms/form-wizard", element: <FormWizard /> },
      { path: "/forms/form-validation", element: <FormValidation /> },
      { path: "/tables/basic", element: <BasicTable /> },
      { path: "/tables/collapsible", element: <CollapsibleTable /> },
      { path: "/tables/enhanced", element: <EnhancedTable /> },
      { path: "/tables/fixed-header", element: <FixedHeaderTable /> },
      { path: "/tables/pagination", element: <PaginationTable /> },
      { path: "/tables/search", element: <SearchTable /> },
      { path: "/charts/line-chart", element: <LineChart /> },
      { path: "/charts/gredient-chart", element: <GredientChart /> },
      { path: "/charts/doughnut-pie-chart", element: <DoughnutChart /> },
      { path: "/charts/area-chart", element: <AreaChart /> },
      { path: "/charts/column-chart", element: <ColumnChart /> },
      { path: "/charts/candlestick-chart", element: <CandlestickChart /> },
      { path: "/charts/radialbar-chart", element: <RadialbarChart /> },
      { path: "/ui-components/alert", element: <MuiAlert /> },
      { path: "/ui-components/accordion", element: <MuiAccordion /> },
      { path: "/ui-components/avatar", element: <MuiAvatar /> },
      { path: "/ui-components/chip", element: <MuiChip /> },
      { path: "/ui-components/dialog", element: <MuiDialog /> },
      { path: "/ui-components/list", element: <MuiList /> },
      { path: "/ui-components/popover", element: <MuiPopover /> },
      { path: "/ui-components/rating", element: <MuiRating /> },
      { path: "/ui-components/tabs", element: <MuiTabs /> },
      { path: "/ui-components/tooltip", element: <MuiTooltip /> },
      { path: "/ui-components/transfer-list", element: <MuiTransferList /> },
      { path: "/ui-components/typography", element: <MuiTypography /> },
      { path: "/widgets/cards", element: <WidgetCards /> },
      { path: "/widgets/banners", element: <WidgetBanners /> },
      { path: "/widgets/charts", element: <WidgetCharts /> },

      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: "/auth/login", element: <Login /> },
      { path: "/auth/login2", element: <Login2 /> },
      { path: "/auth/register", element: <Register /> },
      { path: "/auth/register2", element: <Register2 /> },
      { path: "/auth/forgot-password", element: <ForgotPassword /> },
      { path: "/auth/forgot-password2", element: <ForgotPassword2 /> },
      { path: "/auth/two-steps", element: <TwoSteps /> },
      { path: "/auth/two-steps2", element: <TwoSteps2 /> },
      { path: "/auth/maintenance", element: <Maintenance /> },
      { path: "/landingpage", element: <Landingpage /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
